import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../Button'
import Div from '../Div'
import './post.scss'

export default function PostStyle2({ thumb, title, subtitle, date, category, href }) {


  const createDate =   new Date(date)?.toLocaleString()?.split(",")[0];
  const changeToText = (content) => {
    if(content === "" || content === undefined || content === null) return "";
      const sliceData = content?.slice(0, 200);
    return <div dangerouslySetInnerHTML={{__html:sliceData}}/>
  }


  return (
    <Div className="cs-post cs-style2">
      <Link to={href} className="cs-post_thumb cs-radius_15">
        <img src={thumb} alt="Post" className="w-100 cs-radius_15" />
      </Link>
      <Div className="cs-post_info">
        <Div className="cs-post_meta cs-style1 cs-ternary_color cs-semi_bold cs-primary_font">
          <span className="cs-posted_by">{createDate}</span>
          <Link to={`/blog/filterData/category:${category?.name?.toLowerCase()}/type:${"category"}`} className="cs-post_avatar">{category?.name}</Link>
        </Div>
        <h2 className="cs-post_title"><Link to={href}>{title}</Link></h2>
        <Div className="cs-post_sub_title">{changeToText(subtitle)}</Div>
        <Button btnLink={href} btnText='See More' />
      </Div>
    </Div>
  )
}
